module.exports = __webpack_public_path__ + "/img/QFN-Labeled-EmotY3.svg";